export default "__VITE_ASSET__0a7b321d__"